﻿import { DataGrid } from "@serenity-is/corelib";
import { Criteria, deepClone, ListRequest, ListResponse, serviceCall } from "@serenity-is/corelib/q";
import { Column } from "@serenity-is/sleekgrid";
import { HeaderFiltersPlugin, HeaderFilterType } from "./HeaderFiltersPlugin";

export interface HeadersFiltersMixinOptions {
    grid: DataGrid<any, any>;
    filterByText?: boolean;
}

/**
 * A mixin that can be applied to a DataGrid for column filters functionality
 */
export class HeaderFiltersMixin {

    private filterByText: boolean;

    constructor(options: HeadersFiltersMixinOptions) {
        
        var skipColumnFilters: Column = null;
        var cache: any = {};

        if (options.filterByText == null) {
            this.filterByText = !options.grid.view.url || 
                !options.grid.view['getPagingInfo']().rowsPerPage;
        }
        else
            this.filterByText = !!options.filterByText;

        var filterPlugin = new HeaderFiltersPlugin({
            getFilterType: (col: Column) => {
                if (this.filterByText)
                    return HeaderFilterType.text;

                if (col.sortable != null && !col.sortable)
                    return HeaderFilterType.disabled;

                if (col.sourceItem != null && 
                    col.sourceItem.notFilterable != null &&
                    col.sourceItem.notFilterable)
                    return HeaderFilterType.disabled;

                return HeaderFilterType.value;
            },
            getFilterValues: (col: Column, done: (vals: any[]) => void) => {
                if (col.headerFilterType == HeaderFilterType.text)
                    return done(null);

                skipColumnFilters = col;
                try {
                    if (!(options.grid as any).onViewSubmit()) {
                        done([]);
                        return;
                    }
                }
                finally {
                    skipColumnFilters = null;
                }

                var req = deepClone(options.grid.view.params) as ListRequest;
                req.DistinctFields = [col.field];
                req.Skip = 0;
                req.Take = 0;
                var cacheKey = $.toJSON(req);
                var cached = cache[cacheKey];
                if (cached && cached.expires > new Date().getTime())
                    done(cached.value);
                else {
                    serviceCall({
                        request: req,
                        url: options.grid.view.url,
                        onSuccess: (response: ListResponse<any>) => {
                            cache[cacheKey] = {
                                value: response.Values,
                                expires: new Date().getTime() + 1000 * 30
                            };
                            done(response.Values);
                        }
                    });
                }
            }
        });

        filterPlugin.onFilterApplied.subscribe((e, data) => {
            var column = data.column as Column;
            if (column && column.headerFilterType == HeaderFilterType.text)
                options.grid.view.setItems(options.grid.view.getItems(), true);
            else
                options.grid.refresh();
        });

        options.grid.slickGrid.registerPlugin(filterPlugin);

        var me = this;

        var oldOnViewSubmit = (options.grid as any).onViewSubmit;
        (options.grid as any).onViewSubmit = function () {
            if (!oldOnViewSubmit.call(this))
                return false;

            var cols = this.slickGrid.getColumns() as Column[];
            var request = (this.view.params as ListRequest);
            for (var col of cols) {
                if (col === skipColumnFilters ||
                    col.headerFilterType == HeaderFilterType.text)
                    continue;

                var vals = col.headerFilterValues;
                if (vals && vals.length) {
                    var nonNull = vals.filter((z: any) => z != null);
                    var criteria = Criteria(col.field).in(nonNull);
                    if (nonNull.length !== vals.length) {
                        if (nonNull.length > 0)
                            criteria = Criteria.or(Criteria(col.field).isNull(), criteria);
                        else
                            criteria = Criteria(col.field).isNull();
                    }

                    request.Criteria = Criteria.and(request.Criteria, criteria);
                }
            }

            return true;
        };

        var oldOnViewFilter = (options.grid as any).onViewFilter;
        (options.grid as any).onViewFilter = function (item: any) {
            if (!oldOnViewFilter.apply(this, arguments))
                return false;

            var cols = this.slickGrid.getColumns() as Column[];
            for (var col of cols) {
                if (col.headerFilterType != HeaderFilterType.text)
                    continue;

                var vals = col.headerFilterValues;
                if (vals && vals.length) {
                    var filterValue = filterPlugin.getFilterValue(item, col);
                    if (vals.indexOf(filterValue) < 0)
                        return false;
                }
            }

            return true;
        };
    }
}